import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  // プログレスバーの初期化は main.js にある。
  router.app.$Progress.start();
  // 以下、ログインが必要な場合。 この関数は router.beforeEach に登録する
  //（か、または普通に to, from, next を引数として与えて呼び出す）。
  // 厳密には、 to.matched をループさせる必要がある。参考:
  // https://router.vuejs.org/en/advanced/meta.html
  // …が、 child component など使っていないし、また、
  // 仮に使っているからと言ってまるごとログインページに飛ばすのはどうかと思う。
  // なお、当然だが、ここはフロントンドなので使用者が認証をごまかすことは可能。
  // 要するに、ここの設定は、セキュリティのためではなく、ログインページにリダイレクトしたりするためにある。
  // バックエンドの auth でも似たような処理を行っており、そっちが厳密な認証になる。
  if (to.meta.auth !== undefined) {
    // こういうヘッダでやる慣習らしい。参考:
    // https://stackoverflow.com/questions/33265812/best-http-authorization-header-type-for-jwt
    const headers = { authorization: `Bearer ${localStorage.token}` };
    (async () => {
      const response = await fetch(
        `${process.env.BACK_ORIGIN}/auth_and_renew_token`,
        {
          headers: headers
        }
      );
      const jsonObj = await response.json();
      if (!jsonObj.auth) {
        // そもそもログインしていないので /login に移動する。
        next({ name: "LoginComponent", query: { nextPath: to.fullPath } });
        return;
      }
      // フロントの token を更新する。 computed な sitter 又は member も更新される。
      localStorage.token = jsonObj.token;
      // localStorage に token がセットされた段階で、 global mixin の user が使用できる。
      const user = router.app.getUser();
      if (user.type === "sitter") {
        if (
          to.meta.auth.sitter === undefined ||
          to.meta.auth.sitter.length === 0
        ) {
          alert("サポーターさんはこのページにアクセスすることは出来ません。");
          router.app.$Progress.finish();
          return;
        } else if (
          to.meta.auth.sitter[0] === true ||
          to.meta.auth.sitter.indexOf(user.status) !== -1
        ) {
          // 全てのチェックに通過したのでオッケー。
          next();
          return;
        } else {
          // ステータスが一致していない場合。ここどうすれば良いのか不明。
          alert("サポーターさんのステータスが不正です。");
          router.app.$Progress.finish();
          return;
        }
      } else if (user.type === "member") {
        if (
          to.meta.auth.member === undefined ||
          to.meta.auth.member.length === 0
        ) {
          alert("保護者さまはこのページにアクセスすることは出来ません。");
          router.app.$Progress.finish();
          return;
        } else if (
          to.meta.auth.member[0] === true ||
          to.meta.auth.member.indexOf(user.status) !== -1
        ) {
          // 全てのチェックに通過したのでオッケー。
          next();
          return;
        } else {
          // メンバーのステータスが満たされていない場合、その旨を表示する必要がある。
          if (
            // ユーザー（このブロック中ではメンバー）のステータスが審査中で
            user.status === 1 &&
            // 審査結果有効のみのステータスが必要な場合。
            to.meta.auth.member.length === 1 &&
            to.meta.auth.member[0] === 3
          ) {
            // TODO: ここにモーダル生成を作る？
            alert("審査完了までしばらくお待ちください。");
            router.app.$Progress.finish();
            return;
          } else {
            // TODO: ここは単にステーテスが満たされていない場合だが、どうする？
            alert(
              `ステータスが満たされていません。必要: ${
                to.meta.auth.member
              }, 今: ${user.status}`
            );
            router.app.$Progress.finish();
            // next({path: from.fullPath});
            return;
          }
        }
      } else {
        // user.type が "sitter" でも "member" でもない場合。意味不明。
        throw "不正なトークンです。";
      }
    })();
    // この return は必要。または最後のところを else にするか…。
    return;
  }
  // そもそもチェックが不要な場合。
  next();
});

router.afterEach((to, from) => {
  router.app.$Progress.finish();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js